import { useCallback } from 'react';
import { SectionNavigation } from '../constants/common';
import useLocalNavigation from './useLocalNavigation';

export default function useSectionNavigation() {
	const { setView, goToParentView, goToRootView, isViewActive, isChildViewActive, getViewParams, findViewDefinition, generateViewHash } =
		useLocalNavigation<SectionNavigation>('section', SectionNavigation.HOME);

	return {
		changeNavigationView: useCallback(
			(view: SectionNavigation, params: Record<string, string | number> = {}) => {
				if (![SectionNavigation.HOME, SectionNavigation.CP_COUPON].includes(view)) {
					window.scrollTo(0, 0);
				}
				setView(view, params);
			},
			[setView],
		),
		goToFirstNavigationView: useCallback(
			(view: SectionNavigation) => {
				if (![SectionNavigation.HOME, SectionNavigation.CP_COUPON].includes(view)) {
					window.scrollTo(0, 0);
				}
				setView(view, { stepId: 1 });
			},
			[setView],
		),
		isMainView: useCallback(
			() => isViewActive(SectionNavigation.HOME) || isViewActive(SectionNavigation.COUPON_LIST) || isViewActive(SectionNavigation.USER, true),
			[isViewActive],
		),
		getViewParams: useCallback(
			() => getViewParams(findViewDefinition(SectionNavigation) || SectionNavigation.HOME),
			[findViewDefinition, getViewParams],
		),
		findViewDefinition,
		goToParentView,
		goToRootView,
		isViewActive,
		isChildViewActive,
		generateViewHash,
	};
}
